module.exports = __webpack_public_path__ + "img/building.7d237032.svg";